module.exports = __webpack_public_path__ + "media/flags/ec-c35ac1e0.svg";